import { Component, OnInit } from '@angular/core';
import { Validators, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { LoadingController, ToastController } from '@ionic/angular';
import { BackendService } from '../core/services/backend-prod.service';
import { HelperService } from '../core/services/helper.service';
import { NavigationStart, Router } from '@angular/router';
import { SafeHtml,DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.page.html',
  styleUrls: ['./forgot-password.page.scss'],
})
export class ForgotPasswordPage implements OnInit {

  forgotform = new UntypedFormGroup({});
  submitted: boolean = false;
  loading: boolean = false;
  emailSent: boolean=false;
  showSuccessMessage: boolean=false;
  msg:SafeHtml = 'Please enter your email address. We will send you an email to reset your password';
  token: any;
  verifyemail: string;

  constructor(
    private fb: UntypedFormBuilder,
    private backendService: BackendService,
    public helperService: HelperService,
    public toastController: ToastController,
    public router: Router,
    private sanitizer: DomSanitizer,
    public loadingController: LoadingController) { }
    
  ngOnInit() {   
    this.forgotform = this.fb.group({
      'email': ['', [Validators.required, Validators.email]]
    }); 
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
       this.helperService.dismissToast();
      }
    }); 
  }

  get f() { return this.forgotform.controls; }

  onSubmitforgot() {
    if (this.forgotform.invalid) {
      this.helperService.presentToast("Form incomplete", 2000);
      return;
    }
    this.submitted = true;
    if(this.helperService.toast){
      this.helperService.dismissToast();
    }
    // this.helperService.loader();
    let payload = {      
      email : this.forgotform.value.email
    }
    this.backendService.PostAPICall('forgotPassword', payload, this.token).subscribe(
      data => {
        // this.appRouter.gotoPath('login');
        this.showSuccessMessage=true; 
         this.msg = this.sanitizer.bypassSecurityTrustHtml(
         `The password reset link has been sent successfully to <span style="color:red;"> ${this.forgotform.value.email}</span> . The link is valid for 30 minutes`
         );
      }, 
      err =>{
        //console.log(err);
        if(err.error.isTrusted){
          this.helperService.presentToastWithButton("Try again"); 
        }else{
          if(err.error.detail.includes("400:")){
            this.helperService.presentToastWithButton(err.error.detail.split(":")[1]); 
          }else{
            this.helperService.presentToastWithButton(err.error.detail); 
          }
        }
        // this.helperService.presentToast("Oops! something went wrong", 2000);
      }
    ); 
  
  
  }   

}
